import { useQuery } from '@apollo/client'
import type { GetModuleAvailabilitiesQuery } from 'generated/resources/graphql'
import { GetModuleAvailabilitiesDocument } from 'generated/resources/graphql'

interface DefaultModuleAvailabilityType {
  _internalType: 'module'
  available: boolean
  id: string
}

export type ModuleAvailabilityType =
  | GetModuleAvailabilitiesQuery['companies']['moduleAvailabilities'][number]
  | DefaultModuleAvailabilityType

// Get the module avavilability for the current company or a specific one.
//
// The availability of a module is derived of the availabilities of the features that formed the module.
// If one featue is available the module will be available
//
// - Get the module availability
//    `useModuleAvailability('expenses')`
// - Get the module availability for a specific company
//    `useModuleAvailabilities('payroll', companyId)`
/**
 * @deprecated Please include this query into the Page query
 */
export const useModuleAvailability = (moduleId: string, companyId?: string) => {
  const { loading, data, refetch } = useQuery(GetModuleAvailabilitiesDocument, {
    variables: { ids: [moduleId], companyId },
  })

  const moduleAvailability: ModuleAvailabilityType = data?.companies.moduleAvailabilities[0] ?? {
    available: false,
    id: moduleId,
    _internalType: 'module',
  }

  return {
    loading,
    refetch,
    moduleAvailability,
  }
}
